import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignRightSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 19h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V9H9v2zM3 5v2h18V5H3z" />
  </svg>
);
export default IconAlignRightSizeM;
